import { RealPipe } from 'src/app/pipes/real/real.pipe';
import { TopPrioridadesDto } from './../../dto/topPrioridadesDto';
import { TempoMedioChamadoDto } from './../../entidades/tempoMedioChamado';
import { ItemMinhasCotacoesDto } from './../../dto/itemMinhasCotacoesDto';
import { TopProdutosDto } from './../../dto/topProdutosDto';
import { AgenciaService } from './../../services/agencia/agencia.service';
import { ResumoStatusDashboardDto } from 'src/app/dto/resumoStatusDashboardDto';
import { AppConfigService } from './../../services/app/app-config.service';
import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Usuario } from 'src/app/entidades/usuario';
import { ApiService } from 'src/app/services/api/api.service';
import { MensagemService } from 'src/app/services/mensagem/mensagem.service';
import { Pagina } from 'src/app/entidades/pagina';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { Paginator } from 'src/app/entidades/paginator';
import { PaginatorService } from 'src/app/services/Paginator/Paginator.service';
import { CotacaoService } from 'src/app/services/cotacao/cotacao.service';
import { StatusDashboardDto } from 'src/app/dto/statusDashboardDto';
import { PeriodoDto } from 'src/app/dto/periodoDto';
import {
  ChartConfiguration,
  ChartItem,
  ChartType,
  registerables,
} from 'chart.js';
import { MciService } from 'src/app/services/mci/mci.service';
import { ResumoMCIPorPADto } from 'src/app/dto/resumoMCIPorPADto';
import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { ProdutoService } from 'src/app/services/produto/produto.service';
import { DateAdapter } from '@angular/material/core';
import { ControleParcelasService } from 'src/app/services/controle-parcelas/controle-parcelas.service';
import { ItemPrimeiraParcelaDto } from 'src/app/dto/itemPrimeiraParcelaDto';
import { MatDialog as MatDialog, MatDialogConfig as MatDialogConfig } from '@angular/material/dialog';
import { DialogoComponent } from '../dialogo/dialogo/dialogo.component';
import { TipoChamado } from 'src/app/enum/tipoChamado';
import { ItemFechamentosDiariosDto } from 'src/app/dto/itemFechamentosDiariosDto';
import { ControleVersaoService } from 'src/app/services/controle-versao/controle-versao.service';
import { DeviceUUID } from 'src/assets/js/device-uuid.min.js';
import { AvisoService } from 'src/app/services/aviso/aviso.service';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Subscription } from 'rxjs';

Chart.register(ChartDataLabels);
Chart.register(...registerables);

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css', '../../app.component.css'],
})
export class HomeComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('chart1') chart1!: ElementRef<HTMLCanvasElement>;
  @ViewChild('chart2') chart2!: ElementRef<HTMLCanvasElement>;
  dataItemFechamento1: number[][] = [];
  arrayFechamento1: number[] = [];
  dataItemFechamento2: number[][] = [];
  arrayFechamento2: number[] = [];
  pageSizeOptions: number[];
  pageSizeGrafico: number[] = [7, 14, 21, 30, 100];
  locale: string;
  usuario: Usuario;
  isBusy: boolean;
  paginaMinhasCotacoes: Pagina<ItemMinhasCotacoesDto>;
  paginaPrimeiraParcela: Pagina<ItemPrimeiraParcelaDto>;
  minhasCotacoes: ItemMinhasCotacoesDto[];
  primeirasParcelas: ItemPrimeiraParcelaDto[];
  colunasMeusChamados: string[] = [
    'id',
    'data',
    'nomeCliente',
    'status',
    'visualizar',
  ];
  colunasPrimeiraParcela: string[] = [
    'id',
    'vencimento',
    'nomeCliente',
    'pa',
    'valor',
    'visualizar',
  ];
  dsTempoMedioChamados: MatTableDataSource<TempoMedioChamadoDto>;
  dsMinhasCotacoes: MatTableDataSource<ItemMinhasCotacoesDto>;
  itemCotacaoSelecionado: ItemMinhasCotacoesDto;
  itemParcelaSelecionado: ItemPrimeiraParcelaDto;
  dsPrimeiraParcela: MatTableDataSource<ItemPrimeiraParcelaDto>;
  qtdeRegistrosMinhasCotacoes: number = 0;
  qtdeRegistrosPrimeiraParcela: number = 0;
  qtdeRegistrosCotacoesDiarias: number = 0;
  permissaoADM: boolean;
  permissaoGerente: boolean;
  permissaoAssessor: boolean;
  tempoMedioChamados: TempoMedioChamadoDto;
  mediaAguardandoRetorno: TempoMedioChamadoDto;
  topPrioridades: TopPrioridadesDto[];
  localId: any;
  qtdeFechamentoPA = 0;
  valorFechamentoPA = 0;

  myPaginator1: Paginator = {
    length: 0,
    pageIndex: 0,
    pageSize: this.appConfigService.itensPorPagina,
    previousPageIndex: 0,
  };
  myPaginator2 = {
    length: 0,
    pageIndex: 0,
    pageSize: this.appConfigService.itensPorPagina,
    previousPageIndex: 0,
  };
  myPaginator3 = {
    length: 0,
    pageIndex: 0,
    pageSize: 7,
    previousPageIndex: 0,
  };
  todoPeriodo: boolean = false;
  todoPA: boolean = false;
  dataInicial: Date;
  dataFinal: Date;
  statusDashboard: StatusDashboardDto;
  tituloDashboard: string;
  tituloDashboard1: string;
  tituloDashboard2: string;
  ultimaAtualizacao: string;
  stopTimer: boolean = false;
  barChartData1: Chart;
  barChartData2: Chart;
  barChartData3: Chart;
  barChartData4: Chart;
  barChartData5: Chart;
  private subscriptions = new Subscription();

  public barChartType1: ChartType = 'bar';
  public barChartType2: ChartType = 'bar';
  public barChartType3: ChartType = 'bar';
  public barChartType4: ChartType = 'bar';
  public barChartType5: ChartType = 'line';

  public barChartOptions1: ChartConfiguration<'bar'>['options'] = {
    responsive: true,
    layout: {
      padding: {
        top: 20, // ou mais
      },
    },
    plugins: {
      tooltip: {
        enabled: true,
        backgroundColor: '#333',
        titleColor: '#fff',
        bodyColor: '#fff',
        titleFont: {
          size: 14,
          weight: 'bold',
        },
        bodyFont: {
          size: 12,
        },
        callbacks: {
          title: (tooltipItems) => {
            return `${tooltipItems[0].label}`;
          },
          label: (tooltipItem) => {
            let totalChamados =
              this.dataItemFechamento1[1][tooltipItem.dataIndex];
            let premioLiquido =
              this.dataItemFechamento1[0][tooltipItem.dataIndex];
            return `${totalChamados} chamado(s)    |    Prêmio Líquido R$ ${new RealPipe().transform(
              premioLiquido
            )}`;
          },
        },
      },
      legend: {
        position: 'bottom',
        labels: {
          generateLabels: (chart) => {
            // Retorna apenas os datasets que você realmente quer mostrar na legenda
            return Chart.defaults.plugins.legend.labels
              .generateLabels(chart)
              .filter((label) => {
                return (
                  label.text === 'Prêmio Líquido' || label.text === 'Quantidade'
                );
              });
          },
        },
      },
      datalabels: {
        anchor: 'end',
        align: 'top',
        clamp: true,
        display: true,
        color: '#000',
        font: {
          weight: 'bold',
          size: 10,
        },
        formatter: (value, ctx) =>
          ctx.datasetIndex === 0 ? `${new RealPipe().transform(value)}` : value,
      },
    },
    scales: {
      y: {
        type: 'linear',
        position: 'left',
        title: {
          display: true,
          text: 'Prêmio Líquido',
        },
        ticks: {
          align: 'center',
          crossAlign: 'center',
        },
        beginAtZero: true,
      },
      y1: {
        type: 'linear',
        position: 'right',
        title: {
          display: true,
          text: 'Quantidade',
        },
        ticks: {
          align: 'center',
          crossAlign: 'center',
        },
        beginAtZero: true,
        grid: {
          drawOnChartArea: false, // para não sobrepor a grade do eixo Y principal
        },
      },
    },
  };

  public barChartOptions2: ChartConfiguration<'bar'>['options'] = {
    responsive: true,
    indexAxis: 'y',
    plugins: {
      tooltip: {
        enabled: true,
        backgroundColor: '#333',
        titleColor: '#fff',
        bodyColor: '#fff',
        titleFont: {
          size: 14,
          weight: 'bold',
        },
        bodyFont: {
          size: 12,
        },
        callbacks: {
          title: (tooltipItems) => {
            return `${tooltipItems[0].label}`;
          },
          label: (tooltipItem) => {
            let premioLiquido =
              this.dataItemFechamento2[0][tooltipItem.dataIndex];
            let totalChamados =
              this.dataItemFechamento2[1][tooltipItem.dataIndex];
            return `${totalChamados} chamado(s)    |    Prêmio Líquido R$ ${new RealPipe().transform(
              premioLiquido
            )}`;
          },
        },
      },
      legend: {
        position: 'top',
        labels: {
          generateLabels: (chart) => {
            // Retorna apenas os datasets que você realmente quer mostrar na legenda
            return Chart.defaults.plugins.legend.labels
              .generateLabels(chart)
              .filter((label) => {
                return (
                  label.text === 'Prêmio Líquido'
                );
              });
          },
        },
      },
      datalabels: {
        anchor: 'end',
        align: 'center',
        clamp: true,
        display: true,
        color: '#003641',
        font: {
          weight: 'bold',
          size: 10,
        },
        formatter: (value, ctx) =>
          ctx.datasetIndex === 0 ? `${new RealPipe().transform(value)}` : value,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Prêmio Líquido',
        },
        ticks: {
          align: 'center',
          crossAlign: 'center',
        },
        beginAtZero: true,
      },
      y: {
        title: {
          display: true,
          text: 'Produtos',
        },
      },
    },
  };

  public barChartOptions3: ChartConfiguration<'bar'>['options'] = {
    responsive: true,
    indexAxis: 'y',
  };

  public barChartOptions4 = {
    scaleShowVerticalLines: false,
    responsive: true,
  };
  public barChartOptions5 = {
    scaleShowVerticalLines: true,
    responsive: true,
  };

  // setTimer = () => {
  //   setTimeout(() => {
  //     if (this.stopTimer) return;
  //     this.ultimaAtualizacao = `${new Date().toString()}`;
  //     this.todoPeriodo = false;
  //     this.apiService.IgnoraBusy = true;
  //     this.setDataPadrao();
  //     setTimeout(() => {
  //       this.obterResumos();
  //     }, 250);
  //     this.setTimer();
  //   }, 60000);
  // };

  constructor(
    private dateAdapter: DateAdapter<Date>,
    private apiService: ApiService,
    private mciService: MciService,
    private cotacaoService: CotacaoService,
    private controleParcelasService: ControleParcelasService,
    public appConfigService: AppConfigService,
    private router: Router,
    private mensagemService: MensagemService,
    private agenciaService: AgenciaService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private controleVersaoService: ControleVersaoService,
    private avisoService: AvisoService
  ) {
    this.locale = 'pt-BR';
    this.dateAdapter.setLocale('pt-BR');
    let urlNavigation = sessionStorage.getItem('urlNavigation');
    if (urlNavigation !== null && urlNavigation !== undefined) {
      sessionStorage.removeItem('urlNavigation');
      this.router.navigate([urlNavigation], {
        relativeTo: this.route,
        skipLocationChange: true,
      });
    }
    var uuid = new DeviceUUID().get();
    this.localId = uuid;
  }
  ngAfterViewInit(): void {
    const chartItem: ChartItem = this.chart1.nativeElement;
  }

  ngOnDestroy(): void {
    this.pararTimerChanged(true);
    this.subscriptions.unsubscribe();
  }

  async atualizarSite(versaoSite: string): Promise<void> {
    let versao = null;
    await this.controleVersaoService
      .obterControleVersao(this.localId)
      .then((v) => {
        versao = v;
      });
    let versaoLocal = localStorage.getItem('versao');
    if (versaoLocal !== versaoSite || versaoLocal === 'null') {
      if (versaoLocal === 'null' || versaoSite === 'null') {
        versaoLocal = '0';
        versaoSite = '0';
      }
      await this.controleVersaoService.atualizarVersao(
        this.localId,
        versaoSite
      );
      this.apiService.LocalId = this.localId;
      localStorage.setItem('versao', versao.versaoAtual);
      await this.mensagemService.showMessage(
        'Site atualizado ...',
        'Ok',
        5000,
        'success'
      );
      window.location.reload();
    } else {
      if (versao?.versaoAtual === undefined) {
        this.mensagemService.showMessage(
          `Atenção! Site desatualizado. As novas funcionalidades podem não estar disponíveis. Limpe os dados de  navegação e faça login novamente!`,
          'Ok',
          8000,
          'warning'
        );
      }
    }
    localStorage.setItem('versao', this.apiService.VersaoSite);
  }

  async ngOnInit(): Promise<void> {
    this.tempoMedioChamados = this.getTempoMedioDefault();
    this.pageSizeOptions = [5, 10, 25, 50, 100];
    this.usuario = this.apiService.UsuarioLogado;
    this.permissaoADM = this.usuario?.nivel === 'ADMINISTRADOR';
    this.permissaoAssessor = this.usuario?.nivel === 'ASSESSOR';
    this.permissaoGerente = this.usuario?.nivel === 'OPERADOR';
    // this.subscriptions.add(this.appConfigService.pararTimerEmitter.subscribe((parar) => {
    //   this.pararTimerChanged(parar);
    // }));
    this.ultimaAtualizacao = `${new Date().toString()}`;
    if (
      this.usuario?.nivel === 'ADMINISTRADOR' ||
      this.usuario?.nivel === 'ASSESSOR'
    ) {
      this.tituloDashboard = 'Cotações e Endossos';
      this.tituloDashboard1 = 'Minha Atuação';
      this.tituloDashboard2 = 'Minhas Cotações';
    } else if (this.usuario?.nivel === 'OPERADOR' && this.todoPA) {
      this.tituloDashboard = `Cotações e Endossos do ${this.usuario?.codPA}`;
      this.tituloDashboard1 = `Atuações do ${this.usuario?.codPA}`;
      this.tituloDashboard2 = this.tituloDashboard;
    } else {
      this.tituloDashboard = 'Minhas Cotações e Endossos';
      this.tituloDashboard1 = 'Minha Atuação';
      this.tituloDashboard2 = this.tituloDashboard;
    }
    this.verificaUsuario();
    this.setDataPadrao();
    await this.obterResumos();
    //this.setTimer();
    if (
      sessionStorage.getItem('userCode') !== null &&
      sessionStorage.getItem('userCode') !== undefined
    )
      this.avisoService.avisosEmitter.emit(true);
    setTimeout(() => {
      if (
        sessionStorage.getItem('userCode') !== null &&
        sessionStorage.getItem('userCode') !== undefined
      ) {
        this.appConfigService.minhasAtividadesEmitter.emit(true);
      }
    }, 5000);
    this.subscriptions.add(this.appConfigService.atualizarSiteEmiiter.subscribe(
      async (versao: string) => {
        await this.atualizarSite(versao);
      }
    ));
  }

  getTempoMedioDefault(): TempoMedioChamadoDto {
    return {
      tipo: TipoChamado.Cotacao,
      periodo: undefined,
      qtdeCotacoes: 0,
      totalCotacoes: '0',
      mediaCotacoes: '0',
      qtdeEndossos: 0,
      totalEndossos: '0',
      mediaEndossos: '0',
      qtdeChamados: 0,
      totalChamados: '0',
      mediaGeral: '0',
    };
  }

  getMargin(): string {
    return '25%';
  }

  async getPaginaCotacoes(event: any): Promise<void> {
    this.myPaginator1 = event;
    await this.cotacaoService
      .minhasCotacoes(this.myPaginator1, this.todoPA)
      .then((result) => {
        let minhasCotacoes =
          this.apiService.verificaSeResult<Pagina<ItemMinhasCotacoesDto>>(
            result
          );
        this.configurarPaginaCotacoes(minhasCotacoes);
      });
  }

  async getPaginaParcelas(event: any): Promise<void> {
    await this.controleParcelasService.listaParcelas(event).then((result) => {
      let parcelas =
        this.apiService.verificaSeResult<Pagina<ItemPrimeiraParcelaDto>>(
          result
        );
      this.configurarPaginaParcelas(parcelas);
    });
  }

  verificaUsuario(): void {
    if (this.usuario?.senhaProvisoria) {
      this.router.navigate([`/usuario/edit/senha/${this.usuario?.id}`]);
    }
  }

  todoPeriodoChanged(event: any): void {
    if (event) {
      this.dataInicial = undefined;
      this.dataFinal = undefined;
    }
  }

  todoPAChanged(event: any): void {
    if (this.usuario?.nivel === 'OPERADOR' && this.todoPA) {
      this.tituloDashboard = `Cotações do ${this.usuario?.codPA}`;
      this.tituloDashboard1 = `Atuações do ${this.usuario?.codPA}`;
      this.tituloDashboard2 = this.tituloDashboard;
    } else {
      this.tituloDashboard = 'Minhas Cotações';
      this.tituloDashboard1 = `Minha Atuação`;
      this.tituloDashboard2 = this.tituloDashboard;
    }
  }

  async getPeriodo(): Promise<PeriodoDto> {
    let dtInicial = this.dataInicial;
    let dtFinal = this.dataFinal;

    if (
      dtInicial !== null &&
      dtInicial !== undefined &&
      dtFinal !== null &&
      dtFinal !== undefined
    ) {
      //this.todoPeriodo = false;
      let check = document.getElementById('todoPeriodoCheck');
      if (check) (<any>check).value = false;
    }

    if (this.todoPeriodo) {
      dtInicial = await this.apiService.DataBase();
      dtFinal = await this.apiService.DataBase();
    }
    let periodo = { dataInicial: dtInicial, dataFinal: dtFinal } as PeriodoDto;
    return periodo;
  }

  async obterResumos(): Promise<void> {
    let periodo = await this.getPeriodo();
    if (
      periodo.dataFinal === null ||
      periodo.dataFinal === null ||
      periodo.dataFinal === undefined ||
      periodo.dataFinal === undefined
    ) {
      await this.mensagemService.showMessage(
        'Informe o período!',
        'Ok',
        3000,
        'warning'
      );
      return;
    }
    //this.apiService.topPrioridadesEmitter.emit(await this.getPeriodo());
    await this.cotacaoService
      .obterResumoStatus(periodo, this.todoPA)
      .then((res) => {
        if (res) {
          let resumo = res as any as ResumoStatusDashboardDto;
          if (resumo.resumoStatus === null || resumo.resumoStatus === undefined)
            return;
          this.statusDashboard = {
            idAbertos: resumo.statusDashboard.idAbertos,
            qtdeAbertos:
              resumo.resumoStatus.filter(
                (x) => x.statusId === resumo.statusDashboard.idAbertos
              )[0]?.totalStatus ?? 0,
            idAguardandoVistoria: resumo.statusDashboard.idAguardandoVistoria,
            qtdeAguardandoVistoria:
              resumo.resumoStatus.filter(
                (x) =>
                  x.statusId === resumo.statusDashboard.idAguardandoVistoria
              )[0]?.totalStatus ?? 0,
            idSolicitandoFechamento:
              resumo.statusDashboard.idSolicitandoFechamento,
            qtdeSolicitandoFechamento:
              resumo.resumoStatus.filter(
                (x) =>
                  x.statusId === resumo.statusDashboard.idSolicitandoFechamento
              )[0]?.totalStatus ?? 0,
            idSolicitandoAlteracao:
              resumo.statusDashboard.idSolicitandoAlteracao,
            qtdeSolicitandoAlteracao:
              resumo.resumoStatus.filter(
                (x) =>
                  x.statusId === resumo.statusDashboard.idSolicitandoAlteracao
              )[0]?.totalStatus ?? 0,
            idAguardandoBoleto: resumo.statusDashboard.idAguardandoBoleto,
            qtdeAguardandoBoleto:
              resumo.resumoStatus.filter(
                (x) => x.statusId === resumo.statusDashboard.idAguardandoBoleto
              )[0]?.totalStatus ?? 0,
            idCotandoInterno: resumo.statusDashboard.idCotandoInterno,
            qtdeCotandoInterno:
              resumo.resumoStatus.filter(
                (x) => x.statusId === resumo.statusDashboard.idCotandoInterno
              )[0]?.totalStatus ?? 0,
            idPendencias: resumo.statusDashboard.idPendencias,
            qtdePendencias:
              resumo.resumoStatus.filter(
                (x) => x.statusId === resumo.statusDashboard.idPendencias
              )[0]?.totalStatus ?? 0,
            idFechados: resumo.statusDashboard.idFechados,
            qtdeFechados:
              resumo.resumoStatus.filter(
                (x) => x.statusId === resumo.statusDashboard.idFechados
              )[0]?.totalStatus ?? 0,
          } as StatusDashboardDto;
        } else {
          this.mensagemService.showMessage(
            'Erro ao obter resumo dos Status.',
            'Ok',
            5000,
            'error'
          );
          this.statusDashboard = null;
        }
      });
    //await this.getPaginaCotacoesDiarias(this.myPaginator3, this.todoPA);
    if (this.permissaoADM || this.permissaoAssessor) {
    }
    await this.gerarGrafico1(periodo);
    if (this.permissaoADM || this.permissaoAssessor)
      await this.gerarGrafico2(periodo);
    //if (this.permissaoADM || this.permissaoAssessor || this.permissaoGerente) await this.gerarGrafico3(periodo);
    //if (this.permissaoADM || this.permissaoAssessor || this.permissaoGerente) await this.gerarGrafico4(periodo);
    // await this.obterMinhasCotacoes();
    // if (this.permissaoADM || this.permissaoAssessor) await this.obterPrimeiraParcela();
    // /* Tempo Médio dos Chamados */
    // await this.cotacaoService.obterTempoMedioChamados(periodo, TipoChamado.Todos).then(tmc => {
    //   if (tmc)
    //     this.tempoMedioChamados = this.apiService.verificaSeResult<TempoMedioChamadoDto>(tmc);
    //   else
    //     this.tempoMedioChamados = this.getTempoMedioDefault();
    // });
    // /* Tempo Médio Aguardando Retorno */
    // await this.cotacaoService.obterTempoMedioChamados(periodo, TipoChamado.Todos, true).then(tmc => {
    //   if (tmc)
    //     this.mediaAguardandoRetorno = this.apiService.verificaSeResult<TempoMedioChamadoDto>(tmc);
    //   else
    //     this.mediaAguardandoRetorno = this.getTempoMedioDefault();
    // });
  }

  async obterPrimeiraParcela(): Promise<void> {
    // await this.controleParcelasService.listaParcelas(this.myPaginator2).then(result => {
    //   let parcelas = this.apiService.verificaSeResult<Pagina<ItemPrimeiraParcelaDto>>(result);
    //   this.configurarPaginaParcelas(parcelas);
    // });
  }

  configurarPaginaParcelas(pagina: Pagina<ItemPrimeiraParcelaDto>): void {
    if (pagina !== null && pagina !== undefined) {
      this.primeirasParcelas = pagina.dados as ItemPrimeiraParcelaDto[];
    } else {
      this.primeirasParcelas = null;
    }
    this.dsPrimeiraParcela = new MatTableDataSource(this.primeirasParcelas);
    this.paginaPrimeiraParcela = pagina;
    this.qtdeRegistrosPrimeiraParcela =
      this.paginaPrimeiraParcela?.quantidadeRegistros;
  }

  async obterMinhasCotacoes(): Promise<void> {
    return;
    await this.cotacaoService
      .minhasCotacoes(this.myPaginator1, this.todoPA)
      .then((result) => {
        let minhasCotacoes =
          this.apiService.verificaSeResult<Pagina<ItemMinhasCotacoesDto>>(
            result
          );
        this.configurarPaginaCotacoes(minhasCotacoes);
      });
  }

  configurarPaginaCotacoes(pagina: Pagina<ItemMinhasCotacoesDto>): void {
    if (pagina !== null && pagina !== undefined) {
      this.minhasCotacoes = pagina.dados as ItemMinhasCotacoesDto[];
    } else {
      this.minhasCotacoes = null;
    }
    this.dsMinhasCotacoes = new MatTableDataSource(this.minhasCotacoes);
    this.paginaMinhasCotacoes = pagina;
    this.qtdeRegistrosMinhasCotacoes =
      this.paginaMinhasCotacoes?.quantidadeRegistros;
  }

  async gerarGrafico1(periodo: PeriodoDto): Promise<void> {
    let resumo: ResumoMCIPorPADto[];
    this.arrayFechamento1 = [];
    this.dataItemFechamento1 = [];

    let agencias = [];
    let labels = [];
    await this.agenciaService.todas().then((res) => {
      agencias = res;
    });

    agencias.forEach((ag) => {
      labels.push(ag.codPA);
    });

    await this.mciService
      .obterProdutividadePorPA(periodo)
      .then(async (result) => {
        resumo = this.apiService
          .verificaSeResult<ResumoMCIPorPADto[]>(result)
          .sort((a, b) => (a.codPA > b.codPA ? 1 : -1));
        this.qtdeFechamentoPA = resumo.reduce(
          (acc, item) => acc + item.quantidade,
          0
        );
        this.valorFechamentoPA = resumo.reduce(
          (acc, item) => acc + item.valorTotal,
          0
        );

        resumo.forEach((y) => {
          let item = resumo.filter((j) => j.codPA === y.codPA)[0]?.valorTotal;
          this.arrayFechamento1.push(item);
        });
        this.dataItemFechamento1.push(this.arrayFechamento1);
        this.arrayFechamento1 = [];
        resumo.forEach((y) => {
          let item = resumo.filter((j) => j.codPA === y.codPA)[0]?.quantidade;
          this.arrayFechamento1.push(item);
        });
        this.dataItemFechamento1.push(this.arrayFechamento1);
        if (this.barChartData1 === undefined) {
          this.barChartData1 = new Chart(this.chart1.nativeElement, {
            type: 'bar',
            data: {
              datasets: [
                {
                  label: 'Prêmio Líquido',
                  clip: false,
                  data: this.dataItemFechamento1[0],
                  backgroundColor: '#47C41570',
                  hoverBackgroundColor: '#ff634770',
                  order: 1,
                  yAxisID: 'y',
                },
                {
                  label: 'Quantidade',
                  clip: false,
                  data: this.dataItemFechamento1[1],
                  type: 'line',
                  borderColor: '#003641',
                  pointBackgroundColor: '#003641',
                  backgroundColor: '#003641',
                  hoverBackgroundColor: '#47C41570',
                  order: 2,
                  yAxisID: 'y1',
                },
              ],
              labels: labels,
            },
            options: this.barChartOptions1,
          });
        } else {
          this.barChartData1.data.datasets[0].data =
            this.dataItemFechamento1[0];
          this.barChartData1.data.datasets[1].data =
            this.dataItemFechamento1[1];
          this.barChartData1.update();
        }
      });
  }

  async gerarGrafico2(periodo: PeriodoDto): Promise<void> {
    let resumo: TopProdutosDto[];
    this.arrayFechamento2 = [];
    this.dataItemFechamento2 = [];
    await this.mciService.topProdutos(periodo).then(async (result) => {
      resumo = this.apiService.verificaSeResult<TopProdutosDto[]>(result);
    });

      const labels = resumo.map(x => x.produtoNome.substring(0, 40));
      this.dataItemFechamento2.push(resumo.map(x => x.valorTotal));
      this.dataItemFechamento2.push(resumo.map(x => x.quantidade))

      if (this.barChartData2 === undefined) {
        this.barChartData2 = new Chart(this.chart2.nativeElement, {
          type: 'bar',
          data: {
            datasets: [
              {
                label: 'Prêmio Líquido',
                clip: false,
                data: this.dataItemFechamento2[0],
                backgroundColor: '#47C41570',
                hoverBackgroundColor: '#ff634770',
                yAxisID: 'y',
              } ,
            ],
            labels: labels,
          },
          options: this.barChartOptions2,
        });
      } else {
        this.barChartData2.data.datasets[0].data = this.dataItemFechamento2[0];
        this.barChartData2.update();
      }
  }

  // async gerarGrafico4(periodo: PeriodoDto): Promise<void> {
  //   this.barChartLabels4 = [];
  //   this.barChartData4 = null;
  //   let eixoY = [];
  //   let resumo: TopAtendentesDto[];
  //   await this.mciService.topAtendentes(periodo).then(async result => {
  //     resumo = this.apiService.verificaSeResult<TopAtendentesDto[]>(result).sort((x, y) => y.quantidade - x.quantidade);
  //     resumo?.forEach(x => {
  //       if (this.barChartLabels4.indexOf(x.atendenteNome) === -1) {
  //         this.barChartLabels4.push(x.atendenteNome);
  //       }
  //     });

  //     resumo?.forEach(x => {
  //       eixoY.push([x.quantidade]);
  //     });
  //     let atendentes = null;
  //     await this.usuarioService.ObterColaboradores().then(res => {
  //       atendentes = res;
  //     });
  //     let dataItemFechamento: number[][] = [];
  //     let dataLabel: string[] = [];

  //     let arrayFechamento: number[] = [];
  //     this.barChartLabels4.forEach(y => {
  //       let item = resumo.filter(j => j.atendenteNome === y)[0]?.quantidade;
  //       arrayFechamento.push(item);
  //     });
  //     dataItemFechamento.push(arrayFechamento);

  //     atendentes.forEach(h => {
  //       dataLabel.push(h.atendenteNome);
  //     });
  //     let dados: ChartDataSets[] = [];

  //     dados.push({
  //       data: dataItemFechamento[0],
  //       axis: 'y',
  //       fill: false,
  //       label: 'Quantidade',
  //       backgroundColor: '#40418470',
  //       hoverBackgroundColor: '#ff634770',
  //     } as ChartDataSets);

  //     if (this.barChartData4 === null) this.barChartData4 = [];
  //     this.barChartData4 = dados;
  //   });

  async obterFechamentosDiarios(
    periodo: PeriodoDto,
    paginacao: Paginator,
    todoPA: boolean
  ): Promise<Pagina<ItemFechamentosDiariosDto>> {
    return;
    let resumo = null;
    await this.cotacaoService
      .fechamentosDiarios(periodo, paginacao, todoPA)
      .then(async (result) => {
        resumo =
          this.apiService.verificaSeResult<Pagina<ItemFechamentosDiariosDto>>(
            result
          );
      });
    return resumo;
  }

  async getPaginaCotacoesDiarias(
    event: Paginator,
    todoPA: boolean
  ): Promise<void> {
    return;
    let periodo = await this.getPeriodo();
    let resumo = await this.obterFechamentosDiarios(periodo, event, todoPA);
    this.qtdeRegistrosCotacoesDiarias = resumo?.quantidadeRegistros;
    //await this.gerarGrafico5(periodo, event, todoPA);
  }

  // async gerarGrafico5(periodo: PeriodoDto, paginator: Paginator, todoPA: boolean): Promise<void> {
  //   this.barChartLabels5 = [];
  //   this.barChartData5 = null;
  //   let eixoY = [];
  //   let resumo: Pagina<ItemFechamentosDiariosDto>;
  //   resumo = await this.obterFechamentosDiarios(periodo, paginator, todoPA);
  //   resumo?.dados?.forEach(x => {
  //     if (this.barChartLabels5.indexOf(new Date(x.data).toLocaleDateString()) === -1) {
  //       this.barChartLabels5.push(new Date(x.data).toLocaleDateString());
  //     }
  //   });

  //   resumo?.dados?.forEach(x => {
  //     eixoY.push([x.quantidade]);
  //   });
  //   let dataItemFechamento: number[][] = [];
  //   let dataLabel: string[] = [];

  //   let arrayFechamento: number[] = [];
  //   let total = 0;
  //   this.barChartLabels5.forEach(y => {
  //     let item = resumo?.dados?.filter(j => new Date(j.data).toLocaleDateString() === y.toLocaleString())[0]?.quantidade;
  //     total = total + item;
  //     arrayFechamento.push(item);
  //   });
  //   dataItemFechamento.push(arrayFechamento);

  //   arrayFechamento = [];
  //   this.barChartLabels5.forEach(y => {
  //     let item = resumo?.dados?.filter(j => new Date(j.data).toLocaleDateString() === y.toLocaleString())[0]?.premioLiquido;
  //     arrayFechamento.push(item);
  //   });
  //   dataItemFechamento.push(arrayFechamento);

  //   resumo?.dados?.forEach(h => {
  //     dataLabel.push(new Date(h.data).toLocaleDateString());
  //   });
  //   let dados: ChartDataSets[] = [];

  //   dados.push({
  //     data: dataItemFechamento[0],
  //     axis: 'y',
  //     fill: false,
  //     label: 'Quantidade',
  //     borderColor: '#79ba4e',
  //     backgroundColor: '#79ba4e',
  //     pointBackgroundColor: '#BED630',
  //     pointBorderColor: '#BED630'
  //   } as ChartDataSets);

  //   dados.push({
  //     data: dataItemFechamento[1],
  //     axis: 'y',
  //     fill: false,
  //     label: 'Prêmio Líquido',
  //     borderColor: '#003641',
  //     backgroundColor: '#003641',
  //     pointBackgroundColor: '#BED630',
  //     pointBorderColor: '#BED630'
  //   } as ChartDataSets);

  //   if (this.barChartData5 === null) this.barChartData5 = [];
  //   this.barChartData5 = dados;
  // }

  setDataPadrao(): void {
    this.todoPeriodoChanged(false);
    this.dataInicial = new Date();
    this.dataFinal = new Date();
    //this.dataInicial.setDate(this.dataInicial.getDate() - 7);
  }

  pararTimerChanged(event: boolean): void {
    //let check = document.getElementById('pararTimerCheck');
    if (event) {
      this.stopTimer = true;
      this.apiService.IgnoraBusy = false;
    } else {
      this.stopTimer = false;
      this.apiService.IgnoraBusy = true;
      //this.setTimer();
    }
  }

  abrirCotacao(row: ItemMinhasCotacoesDto): void {
    this.router.navigate([`/cotacao/${row.id}`]);
  }

  rowClick(row: ItemMinhasCotacoesDto): void {
    this.itemCotacaoSelecionado = row;
  }

  rowClickParcela(row: ItemPrimeiraParcelaDto): void {
    this.itemParcelaSelecionado = row;
  }
  getCellColor(row: ItemMinhasCotacoesDto): string {
    return row.status.cor;
  }

  async avisarParcela(row: ItemPrimeiraParcelaDto): Promise<void> {
    const dialogRef = this.dialog.open(DialogoComponent, {
      data: {
        titulo: 'Notificar por e-mail',
        pergunta: `A notificação será enviada para o ${row.codPA}. Confirma?`,
      },
      width: '550px',
    });
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result === 'yes') {
        await this.controleParcelasService.notificar(row.id).then((result) => {
          if (result) {
            this.mensagemService.showMessage(
              `Alerta enviado para o ${row.codPA}`,
              'Ok',
              5000,
              'success'
            );
          } else {
            this.mensagemService.showMessage(
              `Não foi possível enviar alerta para o ${row.codPA}`,
              'Ok',
              5000,
              'error'
            );
          }
        });
      }
    });
  }

  getStyle(row: ItemPrimeiraParcelaDto): string {
    if (new Date(row.vencimento) < new Date()) {
      return 'red';
    } else {
      return 'black';
    }
  }

  getAnimation(row: ItemPrimeiraParcelaDto): string {
    if (new Date(row.vencimento) < new Date()) {
      return 'blinker 1s step-start infinite';
    } else {
      return '';
    }
  }

  visualizarTempoChamado(): void {
    /*const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      titulo: 'Tempo Médio da Abertura ao Fechamento - Detalhamento',
      todoPeriodo: this.todoPeriodo,
      dataInicial: this.dataInicial,
      dataFinal: this.dataFinal
    };
    let tDialog = this.dialog.open(TempoMedioDetalhadoComponent, dialogConfig);
    tDialog.afterClosed().subscribe(result => { });*/
    this.mensagemService.showMessage(
      'Em desenvolvimento',
      'OK',
      5000,
      'success'
    );
  }
}
